export function getMyQuestsFilterQuery(state, orgId) {
  let query = {}

  query.organization_id_eq = orgId

  if (state.myquestsfilters.authors_id_in.length > 0) {
    query.authors_id_in = state.myquestsfilters.authors_id_in
  }

  if (state.myquestsfilters.reviewing_compiled_quest_state_in.length > 0) {
    query.reviewing_compiled_quest_state_in =
      state.myquestsfilters.reviewing_compiled_quest_state_in
  }

  if (state.myquestsfilters.name_or_description_cont.trim() !== '') {
    query.name_or_description_cont =
      state.myquestsfilters.name_or_description_cont
  }

  if (state.myquestsfilters.assigned_to_id_in.length > 0) {
    query.assigned_to_id_in = state.myquestsfilters.assigned_to_id_in
  }

  if (state.myquestsfilters.quest_draft_or_state_in.length > 0) {
    query.quest_draft_or_state_in =
      state.myquestsfilters.quest_draft_or_state_in
  }

  return query
}



// WEBPACK FOOTER //
// ./src/utils/myquests.js